// A preset dropdown for one role, grouped by family; ★ marks presets that can be a day's main.
import type { InstrumentRole } from "@eb/shared";
import { familiesOf } from "./setup";

export function PresetSelect({
  role,
  value,
  onChange,
  label,
  testId,
}: {
  role: InstrumentRole;
  value: string;
  onChange: (id: string) => void;
  label: string;
  testId?: string;
}) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} aria-label={label} data-testid={testId}>
      {familiesOf(role).map(({ family, presets }) => (
        <optgroup key={family} label={family}>
          {presets.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
              {p.alternateOnly ? "" : " ★"} — {p.flavour}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
